
import React from "react";
import FieldInputMask from "../fieldInputMask";
const FieldInputNumeroTarjeta = ({colMd, colSm, label, name, onChange, onBlur, value, keyFilter, rows, disabled,formatType,error, errors,required}) => {
    return (
        <>

          {label   &&
           <FieldInputMask maskVariable="(9999 9999 9999 9999)" name={name} label={label} colMd={colMd} errors={errors} required={required}
            value={ value }  onChange={onChange} onBlur ={onBlur}/>
          }

           {!label  &&
            <FieldInputMask maskVariable="(9999 9999 9999 9999)" name={name} colMd={colMd} errors={errors} onBlur ={onBlur}
             value={ value }  onChange={onChange}/>            
            }
        </>
    )
};


export default FieldInputNumeroTarjeta;